







































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { routeName } from '@/constants/route.constants';
import { Customer } from '@/models/DTO/customer/customer.model';
import { CUSTOMERS_MODULE_NAME } from '@/store/modules/customer.module';
import { mapState } from 'vuex';
import PayaFormComponent from '@/components/public/paya-form.component.vue';
import PublicCancelMixin from '@/mixins/public-cancel.mixin';

@Component({
  components: {
    PayaFormComponent
  },
  computed: {
    ...mapState(CUSTOMERS_MODULE_NAME, ['publicCustomer'])
  }
})
export default class PaymentComponent extends mixins(PublicCancelMixin) {
  public publicCustomer: Customer;

  public get code(): string {
    return this.$route.params.tagCode;
  }

  public get routeName(): typeof routeName {
    return routeName;
  }

  public onUpdateOwnerClick() {
    this.$router.replace({
      name: routeName.public.register,
      params: {
        tagCode: this.code
      }
    });
  }

  public async onCancelClick(): Promise<void> {
    this.onCancel();
  }
}
